export const iconSizes = {
    xxs: 8,
    xs: 12,
    sm: 16,
    md: 24,
    lg: 48,
};
